export const COLLECTED_BY_AP_BOOKING = 'AP_BOOKING'
export const COLLECTED_BY_AP_ARRIVAL = 'AP_ARRIVAL'
export const PAYMENT_NOT_REQUIRED = 'NOT_REQUIRED'
